import { r4Client, r4Error } from '@/services'

const EmailCampaignApi = {
  async upcomingByDate (dealerId = null, startDate, endDate) {
    const params = { start_date: startDate, end_date: endDate }
    if (dealerId) {
      params['dealer_id'] = dealerId
    }
    try {
      const resp = await r4Client().get('/api/v1/email_campaigns/scheduled_by_date', { params: params })
      return resp.data
    } catch (error) {
      throw r4Error(error)
    }
  },

  async fetchEmailCampaignsAbbreviated (dealerId) {
    try {
      const resp = await r4Client().get('/api/v1/email_campaigns', { params: { dealer_id: dealerId, view: 'short' } })
      return resp.data
    } catch (error) {
      throw r4Error(error)
    }
  },

  async allCampaignTags () {
    try {
      const resp = await r4Client().get('/api/v1/email_campaigns/all_tags')
      return resp.data
    } catch (error) {
      throw r4Error(error)
    }
  },

  async changeHistory (campaignId) {
    try {
      const resp = await r4Client().get(`/api/v1/email_campaigns/${campaignId}/change_history`)
      return resp.data
    } catch (error) {
      throw r4Error(error)
    }
  },

  async createSplitTest (campaignId, testType) {
    try {
      const response = await r4Client().post(`/api/v1/email_campaigns/${campaignId}/split_tests`, { email_campaign_id: campaignId, test_type: testType })
      return response.data
    } catch (error) {
      throw r4Error(error)
    }
  },

  async updateSplitTest (campaignId, splitTestId, payload) {
    try {
      const response = await r4Client().put(`/api/v1/email_campaigns/${campaignId}/split_tests/${splitTestId}`, payload)
      return response.data
    } catch (error) {
      throw r4Error(error)
    }
  },

  async deleteSplitTest (campaignId, splitTestId) {
    try {
      const response = await r4Client().delete(`/api/v1/email_campaigns/${campaignId}/split_tests/${splitTestId}`)
      return response.data
    } catch (error) {
      throw r4Error(error)
    }
  },

  async promoteSplitTestWinner (campaignId, splitTestId, variantWinner) {
    const payload = { winner: variantWinner }
    try {
      const response = await r4Client().put(`/api/v1/email_campaigns/${campaignId}/split_tests/${splitTestId}/complete_test`, payload)
      return response.data
    } catch (error) {
      throw r4Error(error)
    }
  },

  async copyFrom (campaignId, toDealerId) {
    const payload = { campaign_id: campaignId, to_dealer_id: toDealerId }
    try {
      const response = await r4Client().post(`/api/v1/email_campaigns/${campaignId}/copy_from`, payload)
      return response.data
    } catch (error) {
      throw r4Error(error)
    }
  },

  async fetchDetailsPdf (campaignId) {
    try {
      const response = await r4Client().post(`/api/v1/email_campaigns/${campaignId}/pdf_details`, {})
      return response.data
    } catch (error) {
      throw r4Error(error)
    }
  }
}

export default EmailCampaignApi
